import { makeStyles, mergeClasses } from "@fluentui/react-components";

import { StyleConstants } from "Shared/Styles/StyleConstants";
import { UniversalSearchState } from "./UniversalSearch.types";
import { themeTokens } from "Core/Theme/M365PulseTheme.types";

const useNormalStyles = makeStyles({
    searchResourceContainer: {
        flexGrow: 0,
        maxWidth: "500px"
    },
    input: {
        width: "100%",
        backgroundColor: themeTokens.colorNeutralBackground3,
        color: themeTokens.colorPalettePlatinumForeground2
    },
    popover: {
        width: "100%",
        overflowY: "auto",
        maxHeight: `calc(100vh - ${StyleConstants.headerHeight * 2}px)`
    },
    menuitem: {},
    popoverContainer: {
        width: "300px"
    }
});

const useSmallScreenStyles = makeStyles({
    input: {
        maxWidth: "200px",
        minWidth: "180px"
    },
    popover: {
        maxWidth: "170px"
    }
});
const useBigScreenStyles = makeStyles({
    input: {
        maxWidth: "500px"
    },
    popover: {
        maxWidth: "490px"
    }
});

export const useUniversalSearchStyles = (state: UniversalSearchState) => {
    const { isSmallScreen } = state;
    const styles = useNormalStyles();
    const smallScreenStyles = useSmallScreenStyles();
    const bigScreenStyles = useBigScreenStyles();

    styles.input = isSmallScreen ? mergeClasses(styles.input, smallScreenStyles.input) : mergeClasses(styles.input, bigScreenStyles.input);
    styles.popover = isSmallScreen ? mergeClasses(styles.popover, smallScreenStyles.popover) : mergeClasses(styles.popover, bigScreenStyles.popover);

    return styles;
};
